(function () {
  'use strict';

  var SCRIPT_ID = 'dealer-locator-maps-script';
  var pendingCallbacks = [];
  var mapsLoaded = false;

  // Coopop theme palette: surface #f4f4f5, border #e5e5e5, text #18181b, muted #52525b/#71717a
  var DEALER_MAP_STYLES = [
    { featureType: 'all', elementType: 'geometry', stylers: [{ color: '#f4f4f5' }] },
    { featureType: 'all', elementType: 'labels.text.fill', stylers: [{ color: '#52525b' }] },
    { featureType: 'all', elementType: 'labels.text.stroke', stylers: [{ color: '#f4f4f5' }, { weight: 3 }] },
    { featureType: 'all', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
    { featureType: 'administrative', elementType: 'geometry', stylers: [{ color: '#d4d4d8' }] },
    { featureType: 'administrative.country', elementType: 'geometry.stroke', stylers: [{ color: '#a1a1aa' }] },
    { featureType: 'administrative.locality', elementType: 'labels.text.fill', stylers: [{ color: '#18181b' }] },
    { featureType: 'administrative.neighborhood', elementType: 'labels.text.fill', stylers: [{ color: '#71717a' }] },
    { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#f4f4f5' }] },
    { featureType: 'poi', stylers: [{ visibility: 'off' }] },
    { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#ececec' }] },
    { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#71717a' }] },
    { featureType: 'road', elementType: 'geometry.fill', stylers: [{ color: '#fafafa' }] },
    { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#a1a1aa' }] },
    { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#52525b' }] },
    { featureType: 'road.arterial', elementType: 'geometry.fill', stylers: [{ color: '#f8f8f9' }] },
    { featureType: 'road.arterial', elementType: 'geometry.stroke', stylers: [{ color: '#71717a' }] },
    { featureType: 'road.highway', elementType: 'geometry.fill', stylers: [{ color: '#f5f5f6' }] },
    { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#52525b' }] },
    { featureType: 'road.highway', elementType: 'labels.text.fill', stylers: [{ color: '#18181b' }] },
    { featureType: 'road.local', elementType: 'geometry.fill', stylers: [{ color: '#fafafa' }] },
    { featureType: 'road.local', elementType: 'geometry.stroke', stylers: [{ color: '#a1a1aa' }] },
    { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: '#71717a' }] },
    { featureType: 'transit', stylers: [{ visibility: 'off' }] },
    { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#e8e8ea' }] },
    { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#71717a' }] },
  ];

  function hasMarketingConsent() {
    return window.coopopConsent && typeof window.coopopConsent.marketing === 'function' && window.coopopConsent.marketing();
  }

  function grantConsentForMaps() {
    if (window.coopopConsent && typeof window.coopopConsent.grantAll === 'function') {
      window.coopopConsent.grantAll();
    }
    if (window.coopopConsent && typeof window.coopopConsent.allowMapsScripts === 'function') {
      window.coopopConsent.allowMapsScripts();
    } else if (window.coopopConsent && typeof window.coopopConsent.allowExternalScriptsOnce === 'function') {
      window.coopopConsent.allowExternalScriptsOnce();
    }
    if (window.coopopConsent && typeof window.coopopConsent.unblockScripts === 'function') {
      window.coopopConsent.unblockScripts();
    }
  }

  function flushCallbacks() {
    mapsLoaded = true;
    var callbacks = pendingCallbacks.slice();
    pendingCallbacks = [];
    callbacks.forEach(function (cb) {
      cb();
    });
  }

  function waitForMapsApi(callback, onError) {
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;

      if (window.google && window.google.maps && typeof window.google.maps.Map === 'function') {
        window.clearInterval(timer);
        callback();
        return;
      }

      if (attempts >= 150) {
        window.clearInterval(timer);
        onError();
      }
    }, 100);
  }

  function loadGoogleMaps(apiKey, callback) {
    if (!apiKey) {
      return;
    }

    if (window.google && window.google.maps && typeof window.google.maps.Map === 'function') {
      mapsLoaded = true;
      callback();
      return;
    }

    pendingCallbacks.push(callback);

    var existing = document.getElementById(SCRIPT_ID);
    if (existing) {
      var blockedSrc = existing.getAttribute('data-consent-blocked-src');
      if (blockedSrc) {
        grantConsentForMaps();
        existing.setAttribute('data-consent-explicit-load', 'true');
        existing.removeAttribute('data-consent-blocked-src');
        existing.src = blockedSrc;
      }

      waitForMapsApi(flushCallbacks, function () {
        pendingCallbacks = [];
        document.dispatchEvent(new CustomEvent('dealer-locator:maps-error'));
      });
      return;
    }

    window.__dealerLocatorMapsInit = function () {
      flushCallbacks();
    };

    grantConsentForMaps();

    var script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.setAttribute('data-consent-explicit-load', 'true');
    script.src =
      'https://maps.googleapis.com/maps/api/js?key=' +
      encodeURIComponent(apiKey) +
      '&callback=__dealerLocatorMapsInit&libraries=places,geometry';
    script.onerror = function () {
      pendingCallbacks = [];
      document.dispatchEvent(new CustomEvent('dealer-locator:maps-error'));
    };
    document.head.appendChild(script);

    waitForMapsApi(flushCallbacks, function () {
      pendingCallbacks = [];
      document.dispatchEvent(new CustomEvent('dealer-locator:maps-error'));
    });
  }

  function DealerLocator(root) {
    this.root = root;
    this.apiKey = root.getAttribute('data-api-key') || '';
    this.searchInput = root.querySelector('[data-dealer-search]');
    this.searchButton = root.querySelector('[data-dealer-submit]');
    this.clearButton = root.querySelector('[data-dealer-clear]');
    this.cardsContainer = root.querySelector('[data-dealer-cards]');
    this.scrollTrack = root.querySelector('[data-dealer-scroll-track]');
    this.scrollFill = root.querySelector('[data-dealer-scroll-fill]');
    this.emptyState = root.querySelector('[data-dealer-empty]');
    this.mapElement = root.querySelector('[data-dealer-map]');
    this.consentOverlay = root.querySelector('[data-dealer-consent]');
    this.consentButton = root.querySelector('[data-dealer-consent-load]');
    this.loadingOverlay = root.querySelector('[data-dealer-loading]');
    this.errorOverlay = root.querySelector('[data-dealer-error]');

    this.map = null;
    this.allMarkers = [];
    this.visibleMarkers = [];
    this.infoWindows = [];
    this.inputPlace = null;
    this.autocomplete = null;
    this.initialized = false;
    this.loadStarted = false;
  }

  DealerLocator.prototype.getCards = function () {
    return Array.from(this.root.querySelectorAll('[data-dealer-card]'));
  };

  DealerLocator.prototype.updateScrollProgress = function () {
    if (!this.cardsContainer || !this.scrollFill || !this.scrollTrack) {
      return;
    }

    var container = this.cardsContainer;
    var maxScroll = container.scrollWidth - container.clientWidth;

    if (maxScroll <= 0) {
      this.scrollTrack.classList.add('is-hidden');
      this.scrollFill.style.width = '100%';
      return;
    }

    this.scrollTrack.classList.remove('is-hidden');
    var ratio = container.scrollLeft / maxScroll;
    var minFill = 0.15;
    var fill = minFill + ratio * (1 - minFill);
    this.scrollFill.style.width = Math.min(100, Math.max(0, fill * 100)) + '%';
  };

  DealerLocator.prototype.bindScrollProgress = function () {
    var self = this;

    if (!this.cardsContainer) {
      return;
    }

    this.cardsContainer.addEventListener('scroll', function () {
      self.updateScrollProgress();
    }, { passive: true });

    window.addEventListener('resize', function () {
      self.updateScrollProgress();
    });

    window.requestAnimationFrame(function () {
      self.updateScrollProgress();
    });
  };

  DealerLocator.prototype.getCardLocation = function (card) {
    return {
      lat: parseFloat(card.getAttribute('data-lat')),
      lng: parseFloat(card.getAttribute('data-lng')),
    };
  };

  DealerLocator.prototype.setOverlayState = function (state) {
    if (this.consentOverlay) {
      this.consentOverlay.classList.toggle('is-hidden', state !== 'consent');
    }
    if (this.loadingOverlay) {
      this.loadingOverlay.classList.toggle('is-hidden', state !== 'loading');
    }
    if (this.errorOverlay) {
      this.errorOverlay.classList.toggle('is-hidden', state !== 'error');
    }
    if (state === 'ready') {
      if (this.consentOverlay) this.consentOverlay.classList.add('is-hidden');
      if (this.loadingOverlay) this.loadingOverlay.classList.add('is-hidden');
      if (this.errorOverlay) this.errorOverlay.classList.add('is-hidden');
    }
  };

  DealerLocator.prototype.closeAllInfoWindows = function () {
    this.infoWindows.forEach(function (infoWindow) {
      infoWindow.close();
    });
    this.infoWindows = [];
  };

  DealerLocator.prototype.getCardProducts = function (card) {
    var raw = card.getAttribute('data-products');
    if (!raw) {
      return [];
    }

    try {
      var products = JSON.parse(raw);
      return Array.isArray(products) ? products : [];
    } catch (error) {
      return [];
    }
  };

  DealerLocator.prototype.buildMarkerIcon = function (productCount) {
    var count = productCount > 0 ? String(productCount) : '';
    var svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="44" viewBox="0 0 36 44">' +
      '<path d="M18 0C8.06 0 0 8.06 0 18c0 13.5 18 26 18 26s18-12.5 18-26C36 8.06 27.94 0 18 0z" fill="#18181b"/>' +
      '<circle cx="18" cy="18" r="7" fill="#fff"/>' +
      (count
        ? '<circle cx="28" cy="8" r="8" fill="#fff" stroke="#18181b" stroke-width="1.5"/>' +
          '<text x="28" y="11.5" text-anchor="middle" font-family="Saira,sans-serif" font-size="10" font-weight="600" fill="#18181b">' +
          count +
          '</text>'
        : '') +
      '</svg>';

    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
      scaledSize: new google.maps.Size(36, 44),
      anchor: new google.maps.Point(18, 44),
    };
  };

  DealerLocator.prototype.escapeHtml = function (value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  };

  DealerLocator.prototype.buildInfoWindowContent = function (card) {
    var self = this;
    var products = this.getCardProducts(card);
    var storeName = card.getAttribute('data-store-name') || '';
    var address = card.getAttribute('data-address') || '';
    var services = card.getAttribute('data-services') || '';
    var locationIcon =
      '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="17" viewBox="0 0 12 17" fill="none" aria-hidden="true">' +
      '<path d="M2.22917 15.9688C1.29861 15.5035 0.833333 14.9028 0.833333 14.1667C0.833333 13.8333 0.934028 13.5243 1.13542 13.2396C1.33681 12.9549 1.61806 12.7083 1.97917 12.5L3.29167 13.7292C3.16667 13.7847 3.03125 13.8472 2.88542 13.9167C2.73958 13.9861 2.625 14.0694 2.54167 14.1667C2.72222 14.3889 3.13889 14.5833 3.79167 14.75C4.44444 14.9167 5.125 15 5.83333 15C6.54167 15 7.2257 14.9167 7.88542 14.75C8.54514 14.5833 8.96528 14.3889 9.14583 14.1667C9.04861 14.0556 8.92361 13.9653 8.77083 13.8958C8.61806 13.8264 8.47222 13.7639 8.33333 13.7083L9.625 12.4583C10.0139 12.6806 10.3125 12.934 10.5208 13.2188C10.7292 13.5035 10.8333 13.8194 10.8333 14.1667C10.8333 14.9028 10.3681 15.5035 9.4375 15.9688C8.50694 16.434 7.30556 16.6667 5.83333 16.6667C4.36111 16.6667 3.15972 16.434 2.22917 15.9688ZM5.85417 12.0833C7.22917 11.0694 8.26389 10.0521 8.95833 9.03125C9.65278 8.01042 10 6.98611 10 5.95833C10 4.54167 9.54861 3.47222 8.64583 2.75C7.74306 2.02778 6.80556 1.66667 5.83333 1.66667C4.86111 1.66667 3.92361 2.02778 3.02083 2.75C2.11806 3.47222 1.66667 4.54167 1.66667 5.95833C1.66667 6.88889 2.00694 7.85764 2.6875 8.86458C3.36806 9.87153 4.42361 10.9444 5.85417 12.0833ZM5.83333 14.1667C3.875 12.7222 2.41319 11.3194 1.44792 9.95833C0.482639 8.59722 0 7.26389 0 5.95833C0 4.97222 0.177083 4.10764 0.53125 3.36458C0.885417 2.62153 1.34028 2 1.89583 1.5C2.45139 1 3.07639 0.625 3.77083 0.375C4.46528 0.125 5.15278 0 5.83333 0C6.51389 0 7.20139 0.125 7.89583 0.375C8.59028 0.625 9.21528 1 9.77083 1.5C10.3264 2 10.7813 2.62153 11.1354 3.36458C11.4896 4.10764 11.6667 4.97222 11.6667 5.95833C11.6667 7.26389 11.184 8.59722 10.2188 9.95833C9.25347 11.3194 7.79167 12.7222 5.83333 14.1667ZM5.83333 7.5C6.29167 7.5 6.68403 7.33681 7.01042 7.01042C7.33681 6.68403 7.5 6.29167 7.5 5.83333C7.5 5.375 7.33681 4.98264 7.01042 4.65625C6.68403 4.32986 6.29167 4.16667 5.83333 4.16667C5.375 4.16667 4.98264 4.32986 4.65625 4.65625C4.32986 4.98264 4.16667 5.375 4.16667 5.83333C4.16667 6.29167 4.32986 6.68403 4.65625 7.01042C4.98264 7.33681 5.375 7.5 5.83333 7.5Z" fill="currentColor"/>' +
      '</svg>';
    var html = '<div class="dealer-locator__iw">';

    if (services) {
      html += '<div class="dealer-locator__iw-header">';
      html += '<p class="dealer-locator__iw-services">' + self.escapeHtml(services) + '</p>';
      html += '</div>';
    }

    if (address) {
      html += '<p class="dealer-locator__iw-row">';
      html += '<span class="dealer-locator__iw-icon">' + locationIcon + '</span>';
      html += '<span>' + self.escapeHtml(address) + '</span>';
      html += '</p>';
    }

    if (products.length) {
      html += '<div class="dealer-locator__iw-products">';
      html += '<p class="dealer-locator__card-products-label">Verfügbar vor Ort</p>';
      html += '<ul class="dealer-locator__product-chips">';

      products.forEach(function (product) {
        var url = product.url || '/products/' + (product.handle || '');

        html += '<li class="dealer-locator__product-chip-item">';
        html += '<a class="dealer-locator__product-chip" href="' + self.escapeHtml(url) + '" target="_blank" rel="noopener">';

        if (product.image) {
          html +=
            '<img class="dealer-locator__product-chip-img" src="' +
            self.escapeHtml(product.image) +
            '" alt="" width="32" height="32" loading="lazy">';
        }

        html += '<span class="dealer-locator__product-chip-title">' + self.escapeHtml(product.title || '') + '</span>';
        html += '</a></li>';
      });

      html += '</ul></div>';
    }

    html += '</div>';
    return html;
  };

  DealerLocator.prototype.clearActiveCards = function () {
    this.getCards().forEach(function (card) {
      card.classList.remove('is-active');
    });
  };

  DealerLocator.prototype.createMarkerForCard = function (card) {
    var self = this;
    var location = this.getCardLocation(card);

    if (Number.isNaN(location.lat) || Number.isNaN(location.lng)) {
      return null;
    }

    var productCount = parseInt(card.getAttribute('data-product-count'), 10) || 0;
    var storeName = card.getAttribute('data-store-name') || '';

    var marker = new google.maps.Marker({
      position: location,
      map: this.map,
      title: storeName,
      icon: this.buildMarkerIcon(productCount),
    });

    var infoWindowOptions = {
      content: this.buildInfoWindowContent(card),
    };

    if (storeName) {
      infoWindowOptions.headerContent = storeName;
    }

    var infoWindow = new google.maps.InfoWindow(infoWindowOptions);

    marker.addListener('click', function () {
      self.closeAllInfoWindows();
      infoWindow.open(self.map, marker);
      self.infoWindows.push(infoWindow);
    });

    return marker;
  };

  DealerLocator.prototype.addCardListeners = function () {
    var self = this;

    this.getCards().forEach(function (card) {
      card.addEventListener('click', function (event) {
        if (event.target.closest('.dealer-locator__contact-btn') || event.target.closest('.dealer-locator__product-chip')) {
          return;
        }

        var location = self.getCardLocation(card);
        self.clearActiveCards();
        card.classList.add('is-active');

        if (self.map) {
          self.map.setCenter(location);
          self.map.setZoom(14);
          self.closeAllInfoWindows();
        }
      });
    });
  };

  DealerLocator.prototype.showFilteredCards = function (cards) {
    var self = this;

    this.allMarkers.forEach(function (marker) {
      marker.setMap(null);
    });

    if (!cards.length) {
      this.cardsContainer.innerHTML = '';
      this.emptyState.classList.remove('is-hidden');
      return;
    }

    this.emptyState.classList.add('is-hidden');
    this.cardsContainer.innerHTML = cards
      .map(function (card) {
        return card.outerHTML;
      })
      .join('');

    this.addCardListeners();
    this.updateScrollProgress();

    var firstCard = this.getCards()[0];
    if (firstCard) {
      firstCard.classList.add('is-active');
    }

    this.visibleMarkers.forEach(function (marker) {
      marker.setMap(null);
    });
    this.visibleMarkers = [];

    this.getCards().forEach(function (card) {
      var marker = self.createMarkerForCard(card);
      if (marker) {
        self.visibleMarkers.push(marker);
      }
    });
  };

  DealerLocator.prototype.getDistance = function (start, end) {
    var startLatLng = new google.maps.LatLng(start.latitude, start.longitude);
    var endLatLng = new google.maps.LatLng(end.latitude, end.longitude);
    return google.maps.geometry.spherical.computeDistanceBetween(startLatLng, endLatLng);
  };

  DealerLocator.prototype.searchArea = function () {
    var self = this;

    this.closeAllInfoWindows();

    if (!this.searchInput.value.trim()) {
      if (this.originalCardsHtml) {
        this.cardsContainer.innerHTML = this.originalCardsHtml;
        this.emptyState.classList.add('is-hidden');
        this.addCardListeners();
      }

      this.allMarkers.forEach(function (marker) {
        marker.setMap(null);
      });
      this.allMarkers = [];
      this.visibleMarkers = [];

      var restoredCards = this.getCards();
      restoredCards.forEach(function (card) {
        var marker = self.createMarkerForCard(card);
        if (marker) {
          self.allMarkers.push(marker);
          self.visibleMarkers.push(marker);
        }
      });

      this.clearActiveCards();
      if (restoredCards.length && this.map) {
        restoredCards[0].classList.add('is-active');
        this.map.setCenter(this.getCardLocation(restoredCards[0]));
        this.map.setZoom(14);
      } else if (this.map) {
        this.map.setCenter({ lat: 51.1657, lng: 10.4515 });
        this.map.setZoom(6);
      }

      this.updateScrollProgress();
      return;
    }

    if (!this.inputPlace) {
      return;
    }

    if (this.originalCardsHtml) {
      this.cardsContainer.innerHTML = this.originalCardsHtml;
      this.emptyState.classList.add('is-hidden');
    }

    var sourceCards = this.getCards();
    var sortedCards = sourceCards
      .map(function (card) {
        var distance = self.getDistance(
          { latitude: self.inputPlace.lat, longitude: self.inputPlace.lng },
          {
            latitude: parseFloat(card.getAttribute('data-lat')),
            longitude: parseFloat(card.getAttribute('data-lng')),
          }
        );

        return {
          card: card,
          distance: Number.isFinite(distance) ? distance : Infinity,
        };
      })
      .sort(function (a, b) {
        return a.distance - b.distance;
      })
      .map(function (item) {
        return item.card;
      });

    this.showFilteredCards(sortedCards);

    var nearestCard = sortedCards.find(function (card) {
      var location = self.getCardLocation(card);
      return !Number.isNaN(location.lat) && !Number.isNaN(location.lng);
    });

    if (nearestCard && this.map) {
      this.map.setCenter(this.getCardLocation(nearestCard));
      this.map.setZoom(14);
      return;
    }

    if (this.map) {
      this.map.setCenter(this.inputPlace);
      this.map.setZoom(10);
    }

    this.updateScrollProgress();
  };

  DealerLocator.prototype.initAutocomplete = function () {
    var self = this;

    if (!this.searchInput || !window.google || !window.google.maps || !window.google.maps.places) {
      return;
    }

    this.autocomplete = new google.maps.places.Autocomplete(this.searchInput, {
      types: ['geocode'],
    });

    this.searchInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        if (!self.searchButton.disabled) {
          self.searchArea();
        }
      }
    });

    this.searchInput.addEventListener('input', function () {
      if (self.searchInput.value.trim()) {
        self.clearButton.classList.remove('is-hidden');
      } else {
        self.clearButton.classList.add('is-hidden');
      }
      self.searchButton.disabled = true;
      self.inputPlace = null;
    });

    this.autocomplete.addListener('place_changed', function () {
      var place = self.autocomplete.getPlace();
      if (!place.geometry) {
        self.searchButton.disabled = true;
        self.inputPlace = null;
        return;
      }

      self.inputPlace = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      self.searchButton.disabled = false;
    });
  };

  DealerLocator.prototype.resizeMap = function () {
    if (!this.map) {
      return;
    }

    google.maps.event.trigger(this.map, 'resize');

    var cards = this.getCards();
    if (cards.length) {
      this.map.setCenter(this.getCardLocation(cards[0]));
      this.map.setZoom(cards.length === 1 ? 10 : 6);
      return;
    }

    this.map.setCenter({ lat: 51.1657, lng: 10.4515 });
    this.map.setZoom(6);
  };

  DealerLocator.prototype.initMap = function () {
    if (this.initialized || !this.mapElement) {
      return;
    }

    var allCards = this.getCards();
    if (this.cardsContainer) {
      this.originalCardsHtml = this.cardsContainer.innerHTML;
    }

    this.map = new google.maps.Map(this.mapElement, {
      center: { lat: 51.1657, lng: 10.4515 },
      zoom: 6,
      mapTypeControl: true,
      streetViewControl: true,
      fullscreenControl: true,
      styles: DEALER_MAP_STYLES,
    });

    var self = this;
    var renderTimeout = window.setTimeout(function () {
      if (!self.mapElement.querySelector('.gm-style')) {
        self.setOverlayState('error');
      }
    }, 10000);

    google.maps.event.addListenerOnce(this.map, 'idle', function () {
      window.clearTimeout(renderTimeout);
      self.setOverlayState('ready');
      self.resizeMap();
    });

    allCards.forEach(function (card) {
      var marker = self.createMarkerForCard(card);
      if (marker) {
        self.allMarkers.push(marker);
        self.visibleMarkers.push(marker);
      }
    });

    if (allCards.length) {
      allCards[0].classList.add('is-active');
    }

    this.addCardListeners();
    this.initAutocomplete();

    if (this.searchButton) {
      this.searchButton.addEventListener('click', function () {
        self.searchArea();
      });
    }

    if (this.clearButton) {
      this.clearButton.addEventListener('click', function () {
        self.searchInput.value = '';
        self.clearButton.classList.add('is-hidden');
        self.searchButton.disabled = true;
        self.inputPlace = null;
        self.searchArea();
      });
    }

    window.requestAnimationFrame(function () {
      self.resizeMap();
    });
    window.setTimeout(function () {
      self.resizeMap();
    }, 250);

    this.initialized = true;
  };

  DealerLocator.prototype.loadMap = function () {
    var self = this;

    if (!this.apiKey || this.initialized || this.loadStarted) {
      return;
    }

    this.loadStarted = true;
    this.setOverlayState('loading');

    loadGoogleMaps(this.apiKey, function () {
      window.requestAnimationFrame(function () {
        self.initMap();
      });
    });
  };

  DealerLocator.prototype.tryInit = function () {
    if (!this.apiKey || this.initialized || this.loadStarted) {
      return;
    }

    if (!hasMarketingConsent()) {
      this.setOverlayState('consent');
      return;
    }

    this.loadMap();
  };

  DealerLocator.prototype.bindConsent = function () {
    var self = this;

    this.root.querySelectorAll('[data-dealer-consent-load]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (self.initialized) {
          return;
        }
        self.loadStarted = false;
        self.loadMap();
      });
    });

    if (window.coopopConsent && typeof window.coopopConsent.onChange === 'function') {
      window.coopopConsent.onChange(function () {
        self.tryInit();
      });
    }

    document.addEventListener('dealer-locator:maps-error', function () {
      self.loadStarted = false;
      self.setOverlayState('error');
    });
  };

  function initAll() {
    document.querySelectorAll('[data-dealer-locator]').forEach(function (root) {
      var instance = new DealerLocator(root);
      instance.bindScrollProgress();
      instance.bindConsent();
      instance.tryInit();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-dealer-locator]');
    if (!section) {
      return;
    }
    var instance = new DealerLocator(section);
    instance.bindScrollProgress();
    instance.bindConsent();
    instance.tryInit();
  });
})();
